import { _ROLES_BACK } from "../../utils/constants";
import { BaseBudgetInput } from "../../components/budget/BaseBudgetInput";
import { TableFleetOptimisation } from "../../components/budget/fleet-optimisation/TableFleetOptimisation";
import { useEffect, useState } from "react";
import {
  _SAVE_CATEGORY_FLEET_OPTIMISATION,
  _SAVE_DATA_FLEET_OPTIMISATION,
} from "../../utils/constantsSave";
import { sendToFinancialData } from "../../components/budget/BaseBudgetSaveFunctions";

export const InputFleetOptimisation = () => {
  const [saveData, setSaveData] = useState([]);
  const data = _SAVE_DATA_FLEET_OPTIMISATION;
  const save_name_category = _SAVE_CATEGORY_FLEET_OPTIMISATION;

  useEffect(() => {
    if (saveData.length > 0) {
      sendToFinancialData(saveData, save_name_category);
    }
  }, [saveData]);

  return (
    <BaseBudgetInput
      title="Input Fleet Optimisation"
      roles={[_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL]}
      userRole={_ROLES_BACK._ROLE_FLEET_OP}
      enableFlag="dataEntryEnableFleetOp"
      TableComponent={TableFleetOptimisation}
      saveData={saveData}
      setSaveData={setSaveData}
      includeBaseBudgetSave={true}
      arrayData={data}
      saveNameCategory={save_name_category}
    />
  );
};
